import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "inline", "href", "children"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/TextLink/TextLink.js",
  _this = this;
import React from 'react';
import { css } from 'styled-components';
import { noop, testIdProps } from '../../helpers';
import { withTheme } from '../../core/ThemeProvider';
import Text from '../Text';
import { withStyledAttrs } from '../../helpers/styled';
import TextLinkIcon from './TextLinkIcon';
import TextLinkText from './TextLinkText';
var TextLinkWrapper = withTheme(withStyledAttrs(Text, {
  type: 'link'
})(function (_ref) {
  var coreTheme = _ref.coreTheme,
    inline = _ref.inline;
  return css(["align-items:center;color:", ";cursor:pointer;display:inline-flex;transition:color 0.1s ease-in;", " span{padding-right:", "px;line-height:0;}span:last-of-type{padding:0;}&:hover,&:active{color:", ";}"], coreTheme.cl_sec_d1, inline && css(["&&&{font-size:inherit;display:inline;}"]), coreTheme.space_2, coreTheme.cl_sec_d3);
}));
var TextLink = function TextLink(_ref2) {
  var onClick = _ref2.onClick,
    inline = _ref2.inline,
    href = _ref2.href,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(TextLinkWrapper, _extends({
    inline: inline,
    href: href,
    onClick: onClick
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }), children);
};
TextLink.defaultProps = {
  onClick: noop
};
TextLink.Text = TextLinkText;
TextLink.Icon = TextLinkIcon;
export default TextLink;